<template>
   <section>
        <div class="right-card-list" v-for="(item,index) in tradingList" :key="index" @click="detilsClick(item)" style="cursor: pointer;">
            <div class="right-card-main-list">
                <div class="newsImg">
                    <img :src="item.logo" alt="">
                </div>
                <div class="newsTitle">
                    <p>{{item.title}}</p>
                    <div style="margin-top:17px;">
                        <el-tag type="info" v-for="item in item.tips_arr" style="margin-right:10px;" :key="item.id">{{item}}</el-tag>
                    </div>
                    <div class="title clearfix">
                        <div class="Head left">
                            <img :src="item.head_img" alt="">
                        </div>
                            <div class="left newsName">
                             <span>{{item.user_nickname}}</span>
                        </div>
                        <div class="left newsDui">
                            <span>{{item.store_name}}</span>
                        </div>
                        <div class="right newsGuanZhu">
                            <i class="el-icon-view"></i>
                            <span>{{item.see_number}}</span>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
   </section>
</template>

<script>
import Service from "@/api/request/index.js";
	export default {
		name: "rightNews",
        data(){
		   return{
               tradingList:[], //入驻商家列表接口
               // 页码/条数
               queryParams:{
                   page:1,
                   list_rows:15,
               },
           }
        },
        props:{
            keyword:{}
        },
        created() {
            //   入驻商家列表接口
            if(this.keyword) {
                this.$set(this.queryParams, 'keyword', this.keyword)
            }
            this.post62bbeddcaf763();
        },
        mounted(){},
        methods:{
            //哈法看点更多列表
            // hafaMore() {
            //     this.$router.push({
            //         url:'/hafaList',
            //         name:'hafaList'

            //     })
            // }
             //   详情
            detilsClick(item) {
                console.info("window.location.pathnamehafaDetails", window.location.pathnamehafaDetails)
                this.$router.push({
                    url:'/businessmanDetails',
                    name:'businessmanDetails',
                    query: { userId: item.id,report_article_type:3 }
                })
            },
              //入驻商家列表接口
            post62bbeddcaf763() {
                Service.post636a01fbd286d(this.queryParams).then(res=>{
                    console.log("res", res)
                    if(res.code==1) {
                        this.tradingList = res.data.data;
                        this.total = res.data.total;
                        this.currentPage4 = res.data.current_page
                    }
                })
            },
        }
    }
</script>

<style scoped lang="scss">
@import "themePath/Monitor/cl-css";
@import "themePath/railscasts";
/deep/ .right-card {
    width: 330px;
    height: 450px;
    // padding: 24px;
}
/deep/ .right-card-main{
    height: 100%;
    // padding: 24px;
    box-sizing: border-box;
}
/deep/ .right-card-title {
    text-align: center;
    padding: 24px;
    padding-bottom: 16px;
    box-sizing: border-box;
    border-bottom: 1px #EEEEEE solid;
}
/deep/ .el-carousel__container {
    height: 356px;
}
.code-left:last-child::after {
    width: 0;
}
/deep/.cl-code {
    margin:0;
}
/deep/ .cl-right {
    margin-top: 0;
}
.professional  {
    padding: 24px;
    padding-top: 11px;
    box-sizing: border-box;

    p {
        text-align: left;
        margin-bottom: 16px;
        font-size: 16px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        overflow:hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow:ellipsis;
    }
    .newimg {
        width: 282px;
        height: 282px;
        margin-bottom: 16px;
        img {
            width: 100%;
            height: 100%;
            object-fit: fill;
        }
    }
}
.hafa{
    margin-left: 10px;
    font-size: 16px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: bold;
    color: #333333;
}
.moreDetails {
    font-size: 12px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    line-height: 22px;
}
.right-card-list {
    margin-top: 18px;
    width: 330px;
    height: 450px;
    background: #FFFFFF;
}
.right-card-list:first-child {
    margin-top: 0;
}
.newsImg {
     width: 330px;
    height: 330px;
    img {
        border-radius: 4px 4px 0 0;
        width: 100%;
        height: 100%;
        object-fit: fill;
    }
}
/deep/ .el-tag {
    margin-top: 8px;
}
.newsTitle {
    margin: 8px 26px 16px 16px;
    p {
        font-size: 18px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        overflow: hidden; //超出的文本隐藏
        text-overflow: ellipsis; //溢出用省略号显示
        display: -webkit-box;
        white-space: normal; // 默认不换行；
        -webkit-line-clamp: 2; // 超出多少行
        -webkit-box-orient: vertical;
    }
    .title {
        margin-top: 16px;
        .newsName {
            font-size: 14px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: bold;
            color: #666666;
            line-height: 25px;
            margin-left: 8px;
        }
        .newsGuanZhu {
            font-size: 14px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
             
            color: #999999;
            line-height: 25px
        }
    }
}
.Head{
    width: 25px;
    height: 25px;
    img {
        width: 100%;
        height: 100%;
        border-radius: 100%;
    }
}
.newsDui {
    line-height: 25px;
    margin-left: 5px;

}
</style>



// WEBPACK FOOTER //
// src/components/rightNews.vue